module.exports = __webpack_public_path__ + "static/media/BannerIrisFreight@5x.a59088e6.png";